import { StyledUserAvatar } from './UserAvatar.styles';

interface IUserAvatarProps {
  name: string;
  src?: string;
}

export const UserAvatar = ({ name, src = '#' }: IUserAvatarProps) => {
  return <StyledUserAvatar alt={name} src={src} />;
};
